import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { WidgetContainerComponent } from '../widget-container/widget-container.component';
import { LinkWidget } from '../../../../interfaces/view-widget';

@Component({
  selector: 'ol-link-widget',
  templateUrl: './link-widget.component.html',
  styleUrls: ['./link-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [WidgetContainerComponent],
})
export class LinkWidgetComponent {
  widget = input<LinkWidget>({});

  title = computed(() => this.widget().title || '');
  linkUrl = computed(() => this.widget().linkUrl || '');
  linkText = computed(() => this.widget().linkText || '');
  description = computed(() => this.widget().description || '');
  imageUrl = computed(() => this.widget().imageUrl || '');
}
